<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Manage Contractor Payroll</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">HRM</li>
          <li class="breadcrumb-item active" aria-current="page">Manage Contractor Payroll</li>
        </ol>
      </nav>
    </div>
    <div class="head-icons ms-2"></div>
  </div>
  <!-- /Breadcrumb -->
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <div class="d-flex my-xl-auto align-items-center flex-wrap row-gap-3">
        <form [formGroup]="payrollForm" class="d-flex align-items-center flex-wrap row-gap-3">
          <div class="dropdown me-3">
            <select class="form-select" formControlName="selectedBusinessId">
              <option [value]="null" selected disabled>Select Business Entity</option>
              <option *ngFor="let business of businessesList$ | async" [value]="business.id">
                {{ business.businessName | capitalize }}
              </option>
            </select>
          </div>
          <div class="dropdown me-3">
            <select
              id="financialYear"
              formControlName="selectedPayoutFrequency"
              class="form-select"
            >
              <option value="" selected disabled>Select Payout Frequency</option>
              <option *ngFor="let frequency of payoutFrequencies" [value]="frequency">
                {{ frequency | titlecase }}
              </option>
            </select>
          </div>
          <div *ngIf="showYearSelect || showMonthYearSelect" class="dropdown me-3">
            <select id="year" formControlName="selectedYear" class="form-select">
              <option value="" selected disabled>Select Financial Year</option>
              <option *ngFor="let year of years" [value]="year">{{ year }}</option>
            </select>
          </div>
          <div *ngIf="showMonthYearSelect" class="dropdown me-3">
            <select id="month" formControlName="selectedMonth" class="form-select">
              <option value="" selected disabled>Select Month</option>
              <option *ngFor="let month of months" [value]="month.value">{{ month.name }}</option>
            </select>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="d-flex flex-wrap">
    <ng-container *ngIf="displayBatches$ | async as batches">
      <div *ngIf="batches.length === 0" class="text-center p-5">
        <p>No payroll periods found for this selection.</p>
      </div>
      <div *ngFor="let batch of batches" class="card mx-3 payroll-card">
        <ng-container *ngIf="batch.status === PayrollStatus.PENDING; else elseBlock">
          <div class="card-body">
            <p>Payroll for the period:</p>
            <h6 *ngIf="batch.payoutFrequency === PayoutFrequency.DAILY; else dailyPayoutHeading">
              {{ batch.payPeriodStart | date: 'dd MMM' }}
            </h6>
            <ng-template #dailyPayoutHeading>
              <h6>
                {{ batch.payPeriodStart | date: 'dd MMM' }} -
                {{ batch.payPeriodEnd | date: 'dd MMM' }}
              </h6>
            </ng-template>
            <div class="d-flex align-items-center pending-card-body">
              <button class="btn btn-primary" (click)="setupRunningPayroll(batch)">
                Run Payroll
              </button>
            </div>
          </div>
        </ng-container>
        <ng-template #elseBlock>
          <div class="card-body">
            <h6 class="card-title fw-semibold mb-4">
              <ng-container
                *ngIf="
                  batch.status === PayrollStatus.PROCESSED || batch.status === PayrollStatus.PAID;
                  else dateStringBlock
                "
              >
                <button (click)="setupRunningPayroll(batch)" class="nav-link">
                  {{ batch.payPeriodStart | date: 'dd MMM' }} -
                  {{ batch.payPeriodEnd | date: 'dd MMM' }}
                </button>
              </ng-container>
              <ng-template #dateStringBlock>
                {{ batch.payPeriodStart | date: 'dd MMM' }} -
                {{ batch.payPeriodEnd | date: 'dd MMM' }}
              </ng-template>
            </h6>
            <p class="card-subtitle mb-4 text-muted">
              <span class="badge bg-soft-info">{{ batch.status | titlecase }}</span>
              <button
                (click)="setupRunningPayroll(batch, true)"
                *ngIf="
                  !(batch.status === PayrollStatus.PENDING || batch.status === PayrollStatus.PAID)
                "
                class="ms-2 btn btn-outline-primary"
              >
                {{ batch.status === PayrollStatus.PROCESSED ? 'Paid ?' : 'Confirm' }}
              </button>
            </p>
            <div>
              <h6>Net Salary</h6>
              <p>{{ batch.totalAmount | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}</p>
            </div>
            <p class="card-text pt-2">
              Processed on {{ batch.updatedAt | date: 'MMM dd yyyy, H:mm:ss' }}
            </p>
          </div>
          <div class="card-footer d-flex justify-content-between">
            <button
              class="btn btn-outline-info"
              (click)="exportPayrollToCsv(batch)"
              [disabled]="isExporting"
            >
              <span *ngIf="!isExporting || exportingBatchId !== batch.id"
                ><i class="ti ti-download"></i>Export</span
              >
              <span *ngIf="isExporting && exportingBatchId === batch.id"> Exporting...</span>
            </button>
            <button
              (click)="openDeleteModal(deleteModal, batch?.id ?? '')"
              class="btn btn-icon btn-danger"
            >
              <i class="ti ti-trash"></i>
            </button>
          </div>
        </ng-template>
      </div>
    </ng-container>
  </div>
</div>

<!-- Delete Modal -->
<ng-template #deleteModal let-modal>
  <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
      <i class="ti ti-trash-x fs-36"></i>
    </span>
    <h4 class="mb-1">Confirm Delete</h4>
    <p class="mb-3">You want to delete the payroll batch, this can't be undone once you delete.</p>
    <div class="d-flex justify-content-center">
      <button class="btn btn-light me-3" data-bs-dismiss="modal" (click)="onClose()">Cancel</button>
      <button class="btn btn-danger" (click)="deletePayrollBatch(selectedPayrollBatchId)">
        Yes, Delete
      </button>
    </div>
  </div>
</ng-template>
<!-- /Delete Modal -->

<!-- Finalize Payroll Modal -->
<ng-template #finalizePayrollModal let-modal>
  <div class="modal-body">
    <h4 class="m-3 text-center">Confirm Payroll Payment</h4>
    <div>
      <form [formGroup]="payrollPaymentDetailsForm">
        <div class="form-group mb-3">
          <label for="dateOfPayment" class="form-label">Payment Date</label>
          <input
            type="date"
            class="form-control"
            id="dateOfPayment"
            formControlName="dateOfPayment"
            appTrimInput
          />
        </div>
        <div class="form-group mb-3">
          <label for="modeOfPayment" class="form-label">Mode of Payment</label>
          <select class="form-select" id="modeOfPayment" formControlName="modeOfPayment">
            <option value="cash">Cash</option>
            <option value="cheque">Cheque</option>
            <option value="neft">NEFT</option>
            <option value="rtgs">RTGS</option>
            <option value="imps">IMPS</option>
            <option value="upi">UPI</option>
          </select>
        </div>
      </form>
    </div>
    <div class="d-flex justify-content-center">
      <button class="btn btn-light me-3" (click)="onClose()">Cancel</button>
      <button class="btn btn-primary" (click)="finalizePayroll(selectedPayrollBatchId)">
        Confirm Payment
      </button>
    </div>
  </div>
</ng-template>
<!-- /Finalize Payroll Modal -->
